import React from 'react'
import { localizations, codecTypes } from '../config'

import '../styles/edit-form'

const MODE_EDIT = 'MODE_EDIT', MODE_CREATE = 'MODE_CREATE'
const replaceValues = [{key: 0, value: true, name: ''}, {key: 1, name: 'Anonymous'}, {key: 2, name: 'Replace the Caller ID with'}]

const passwordRegex = new RegExp('(?=.*\d)(?=.*[a-z])(?=.*[A-Z])')

const getLabelText = property => localizations[property] || property

const TextInput = ({ item, property, onChange, multiline = false, disabled, type = 'text', value : inputValue, className = '' }) => {
    const value = inputValue || item[property] || ''
    if (multiline) {
        return <textarea className={"form-control " + className} placeholder={getLabelText(property)} value={value} onChange={e => onChange(e.target.value)}></textarea>
    }
    return <input type={type} name={property} disabled={disabled} className={"form-control " + className} placeholder={getLabelText(property)} value={value} onChange={e => onChange(e.target.value)} />
}

const UsernameInput = ({ onChange, user, units }) => {
    const onValueChanged = e => {
        onChange(e.currentTarget['username_type'].value + e.currentTarget['username_unit'].value + e.currentTarget['username_number'].value)
    }
    return (
        <form className="form-inline" onChange={onValueChanged}>
            <select name="username_type" className="form-control" defaultValue="0">
                <option value="0" hidden>Type</option>
                {['Fix', 'Mobile', 'Correspondent', 'Large operations'].map((text, idx) => <option key={idx} value={idx + 1}>{idx + 1}({text})</option>)}
            </select>
            <select name="username_unit" className="form-control" defaultValue="00">
                <option value="00" hidden>Unit</option>
                {units.map(unit => <option key={unit.key} value={'0' + unit.key}>0{unit.key}({unit.name})</option>)}
            </select>
            <input type="text" name="username_number" className="form-control" placeholder="Number" maxLength="4" />
        </form>
    )
}

const DropDown = ({ property, items, defaultValue, onChange, disabled = false }) => (
    <select id={property} name={property} disabled={disabled} className="form-control" onChange={e => onChange(e.target.value)} value={defaultValue ? defaultValue : property}>
        <option hidden>{getLabelText(property)}</option>
        {items.map((item, idx) => (
            (item && (item.key || item.value)) ?
                <option key={idx} value={item.key}>{item.name}</option> :
                <option key={idx} value={item}>{item}</option>)
        )}
    </select>
)

class EditForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            subscriber: this.props.subscriber || { no_pstn: true },
            generatedPassword: undefined,
            validationErrors: []
        }
        this.updateProperty = this.updateProperty.bind(this)
        this.FormField = this.FormField.bind(this)
        this.generatePassword = this.generatePassword.bind(this)
    }
    
    componentWillReceiveProps(props) {
        if (props.subscriber && (!this.props.subscriber || Object.keys(props.subscriber).some(key => props.subscriber[key] != this.props.subscriber[key]))) {
            this.setState({ subscriber: props.subscriber })
        }
    }

    updateProperty(property, value, validator) {
        const properties = {}
        if (property == "did" && value == "") {
            if (confirm("Do you really want to reset the PSTN Number?")) {
                properties["replace_caller_id"] = ""
                properties["replace_id"] = ""
            } else {
                return
            }
        }
        if (property == "changePassword" && value) {
            const newPassword= this.generatePassword()
            this.setState({ generatedPassword: newPassword })
        }
        properties[property] = value
        this.setState({
            subscriber: Object.assign({}, this.state.subscriber, properties)
        })
    }

    generatePassword() {
        var length = 12,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
        for (var i = 0, n = charset.length; i < length; i++) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        if (!passwordRegex.test(retVal)) {
            this.generatePassword()
        }
        return retVal;
    }

    confirmDelete(subscriber) {
        if (confirm('You really want to delete this subscriber?')) {
            this.props.deleteSubscriber(subscriber)
        }
    }

    validate(subscriber, callback) {
        const validationErrors = []
        const validateProperty = (property, pattern) => {
            if (!(subscriber[property] && (pattern ? subscriber[property].match(pattern) : subscriber[property].length > 0))) {
                validationErrors.push(property)
            }
        }

        validateProperty("username", /[1-9]0[1-9][0-9]{4}/)

        if (subscriber.management_ip && subscriber.management_ip.length > 0) {
            validateProperty("management_ip", /^((\d){1,3}\.){3,3}(\d{1,3})$/)
        }
        
        if (subscriber.fixed_ip && subscriber.ip && subscriber.ip.length > 0) {
            validateProperty("ip", /^((\d){1,3}\.){3,3}(\d{1,3})$/)
        }

        if (subscriber.replace_caller_id == "2") {
            validateProperty("replace_id", /^[+]41[0-9]{9}$/)
        }

        validateProperty("name")

        if (!this.props.subscriber) {
            subscriber['password'] = this.state.generatedPassword
            validateProperty("password")
        } else {
            if (subscriber.changePassword) {
                if (confirm("Do you really want to change the password?")) {
                    subscriber['password'] = this.state.generatedPassword
                } else {
                    validationErrors.push("password")
                }
            }
        }

        this.setState({ validationErrors })
        if (validationErrors.length === 0) {
            callback(subscriber)
        }
    }

    FormField({ item, property, children, onChange }) {
        return (
            <div className={'form-group' + (this.state.validationErrors.indexOf(property) >= 0 ? ' invalid' : '')}>
                <label className="col-sm-2 control-label" htmlFor="{property}">{getLabelText(property)}</label>
                <div className="col-sm-10">
                    {children || <TextInput {...{ item, property }} onChange={value => onChange(property, value)} />}
                </div>
            </div>
        )
    }

    render() {
        const FormField = this.FormField
        const { subscriber, generatedPassword } = this.state
        const { home, save, user, config } = this.props
        const mode = this.props.subscriber ? MODE_EDIT : MODE_CREATE
        const didValues = (this.props.subscriber && this.props.subscriber.did ? ['', this.props.subscriber.did] : ['']).concat(this.props.availableNumbers)
        const noPSTN = (subscriber.no_pstn == 1 || subscriber.no_pstn == undefined) ? true : false
        
        return (
            <div className="row edit-form">
                <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="clearfix">
                        <div className="pull-left"><h4>{mode == MODE_EDIT ? 'Edit subscriber ' + subscriber.username : 'Create new subscriber'}</h4></div>
                        <div className="pull-right">
                            <button className="btn btn-default navbar-btn" onClick={home}>
                                <span className="glyphicon glyphicon-remove-circle"></span> Cancel
                            </button>
                            &nbsp;
                            <button className="btn btn-default navbar-btn" onClick={() => this.validate(subscriber, save)}>
                                <span className="glyphicon glyphicon-save"></span> Save
                            </button>
                            {mode == MODE_EDIT &&
                                <span>&nbsp;
                                    <button className="btn btn-default navbar-btn" onClick={() => this.confirmDelete(subscriber)}>
                                        <span className="glyphicon glyphicon-trash"></span> Delete
                                    </button>
                                </span>
                            }
                        </div>
                    </div>
                    <div className="form-horizontal" role="form">
                        <FormField property="username">
                            {mode == MODE_CREATE && <UsernameInput onChange={value => this.updateProperty('username', value)} user={user} units={config.units.filter(unit => user.isUnitAdmin(unit.key))} />}
                            {mode == MODE_EDIT &&
                                <div className="row">
                                    <div className="col-xs-4"><p className="form-control-static">{subscriber.username}</p></div>
                                    <div className="col-xs-4"><p className="form-control-static">Typ: {codecTypes.filter(c => c.key == subscriber.username.substr(0, 1)).map(c => c.name)[0]}</p></div>
                                    <div className="col-xs-4"><p className="form-control-static">Unit: {config.units.filter(u => u.key == subscriber.username.substr(1, 2)).map(u => u.name)[0]}</p></div>
                                </div>
                            }
                        </FormField>
                        <FormField property="password">
                            {mode == MODE_CREATE &&
                                <TextInput item={subscriber} disabled={true} property="password" value={generatedPassword || this.updateProperty('changePassword', true)} />
                            }
                            {mode == MODE_EDIT &&
                                <div className="row">
                                    <div className="col-xs-8 form-control-static">
                                        {subscriber.changePassword ? 
                                            <TextInput item={subscriber} value={generatedPassword} disabled={true} property="password" />
                                            :
                                            <TextInput item={subscriber} disabled={true} property="password" />
                                        }
                                    </div>
                                    <div className="col-xs-4 form-control-static">
                                        <label><input name="changePassword" type="checkbox" checked={subscriber.changePassword} onChange={e => this.updateProperty('changePassword', e.target.checked)}/> Change Password</label>
                                    </div>
                                </div>
                            }
                        </FormField>
                        <FormField item={subscriber} property="name" onChange={this.updateProperty} />
                        <FormField property="description">
                            <TextInput item={subscriber} property="description" multiline="true" onChange={value => this.updateProperty('description', value)} />
                        </FormField>
                        <FormField property="device_type">
                            <DropDown property="device_type" items={config.devices.sort((a, b) => a.name.localeCompare(b.name))} defaultValue={subscriber.device_type} onChange={value => this.updateProperty('device_type', value)} />
                        </FormField>
                        <FormField property="site">
                            <DropDown property="site" items={config.sites} defaultValue={subscriber.site} onChange={value => this.updateProperty('site', value)} />
                        </FormField>
                        <FormField property="did">
                            <div className="row">
                                <div className="col-xs-8 form-control-static">
                                    <DropDown property="did" disabled={noPSTN} items={didValues} defaultValue={subscriber.did} onChange={value => this.updateProperty('did', value)} />
                                </div>
                                <div className="col-xs-4 form-control-static">
                                    <label><input name="no_pstn" type="checkbox" checked={noPSTN} onChange={e => this.updateProperty('no_pstn', e.target.checked)}/> NO PSTN</label>
                                </div>
                            </div>
                        </FormField>
                        <FormField property="replace_caller_id">
                            <div className="row">
                                <div className="col-xs-8 form-control-static">
                                    <DropDown property="replace_caller_id" items={replaceValues} disabled={subscriber.did == '' || subscriber.did == undefined || noPSTN} defaultValue={subscriber.replace_caller_id} onChange={value => this.updateProperty('replace_caller_id', value)} />
                                </div>
                                <div className="col-xs-4 form-control-static">
                                    <TextInput item={subscriber} className={this.state.validationErrors.indexOf("replace_id") >= 0 ? ' invalid' : ''} value={subscriber.replace_id} disabled={subscriber.replace_caller_id != 2 || subscriber.did == '' || subscriber.did == undefined || noPSTN} property="replace_id" onChange={value => this.updateProperty('replace_id', value)} />
                                </div>
                            </div>
                        </FormField>
                        <FormField item={subscriber} property="room_rack" onChange={this.updateProperty} />
                        <FormField item={subscriber} property="switch_port" onChange={this.updateProperty} />
                        <FormField property="ip">
                            <div className="row">
                                <div className="col-xs-8 form-control-static">
                                    <TextInput item={subscriber} disabled={!subscriber.fixed_ip} property="ip" onChange={value => this.updateProperty('ip', value)} />
                                </div>
                                <div className="col-xs-4 form-control-static">
                                    <label><input name="fixed_ip" type="checkbox" checked={subscriber.fixed_ip} onChange={e => this.updateProperty('fixed_ip', e.target.checked)}/> Fixed IP</label>
                                </div>
                            </div>
                        </FormField>
                        <FormField property="management_ip">
                            <div className="row">
                                <div className="col-xs-8 form-control-static">
                                    <TextInput item={subscriber} property="management_ip" onChange={value => this.updateProperty('management_ip', value && value.length > 0 ? value : null)} />
                                </div>
                                <div className="col-xs-4 form-control-static">
                                    <label><input name="management_ip_ssl" type="checkbox" checked={subscriber.management_ip_ssl > 0} onChange={e => this.updateProperty('management_ip_ssl', e.target.checked ? 1 : 0)}/> HTTPS/SSL</label>
                                </div>
                            </div>
                        </FormField>
                        <FormField item={subscriber} property="supported_algorithms" onChange={this.updateProperty} />
                    </div>
                    {(subscriber.created || subscriber.createdby) &&
                        <div className="small text-right">
                            Created
                            {subscriber.createdby && (<span> by '{subscriber.createdby}'</span>)}
                            <span> {subscriber.created}</span>
                        </div>
                    }
                    {(subscriber.modified || subscriber.modifiedby) &&
                        <div className="small text-right">
                            Modified
                            {subscriber.modifiedby && (<span> by '{subscriber.modifiedby}'</span>)}
                            <span> {subscriber.modified}</span>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default EditForm



// WEBPACK FOOTER //
// ./components/EditForm.jsx